import { useDispatch, useSelector } from "react-redux"

const useCompleteTaskModal = () => {
    const dispatch = useDispatch()
    const reduxData = useSelector((state) => state.modal.counseling.completeTaskModal)
    const {isOpen, onChange, taskData} = reduxData
    const setOpen = (open, onChange = () => {}, taskData = {}, useMutation = false, loading = false) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'counseling.completeTaskModal',
            data: {
                ...reduxData,
                isOpen: open,
                onChange,
                taskData,
                useMutation,
                loading
            }
        })
    }
    const setLoad = (load = false) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'counseling.completeTaskModal',
            data: {
                ...reduxData,
                loading: load
            }
        })
    }
    return {
        ...reduxData,
        onChange,
        isOpen,
        taskData,
        open: (onChange = () => {}, taskData = {}, useMutation = false) => {
            setOpen(true, onChange, taskData, useMutation)
        },
        close: () => {
            setOpen(false)
        },
        toggle: () => {
            setOpen(!isOpen)
        },
        setLoad
    }
}

export default useCompleteTaskModal